export const VERIFIED_EXACT_OVERRIDES = new Map([
  ['sets, relations and functions', 'समुच्चय, संबंध एवं फलन'],
  ['sets relations and functions', 'समुच्चय, संबंध एवं फलन'],
  ['set, relation and function', 'समुच्चय, संबंध एवं फलन'],
  ['limits continuity and differentiability', 'सीमा, सततता तथा अवकलनीयता'],
  ['limits, continuity and differentiability', 'सीमा, सततता तथा अवकलनीयता'],
  ['differential equations', 'अवकल समीकरण'],
  ['indefinite integration', 'अनिश्चित समाकलन'],
  ['indefinite integral', 'अनिश्चित समाकल'],
  ['inverse trigonometric functions', 'व्युत्क्रम त्रिकोणमितीय फलन'],
  ['differentiation', 'अवकलन'],
  ['differentiation and applications', 'अवकलन और अनुप्रयोग'],
  ['integration', 'समाकलन'],
  ['definite integration & areas', 'निश्चित समाकलन एवं क्षेत्रफल'],
  ['limits, continuity and differentiability', 'सीमा, सततता तथा अवकलनीयता'],
  ['permutation and combination', 'क्रमचय और संचय'],
  ['sequences and series', 'अनुक्रम और श्रेणी'],
  ['quadratic equations', 'द्विघात समीकरण'],
  ['quadratic equations & inequalities', 'द्विघात समीकरण एवं असमानताएँ'],
  ['vectors & 3d geometry', 'सदिश एवं त्रिविम ज्यामिति'],
  ['vectors and 3d geometry', 'सदिश एवं त्रिविम ज्यामिति'],
  ['probability', 'प्रायिकता'],
  ['straight lines', 'सरल रेखाएँ'],
  ['circle', 'वृत्त'],
  ['parabola', 'परवलय'],
  ['ellipse', 'दीर्घवृत्त'],
  ['hyperbola', 'अतिपरवलय'],
  ['complex numbers', 'समिश्र संख्याएँ'],
  ['matrices and determinants', 'आव्यूह एवं सारणिक'],
  ['units and dimensions', 'मात्रक एवं विमाएँ'],
  ['modern physics', 'आधुनिक भौतिकी'],
  ['ray optics', 'किरण प्रकाशिकी'],
  ['wave optics', 'तरंग प्रकाशिकी'],
  ['current electricity', 'धारा विद्युत'],
  ['electrostatics', 'स्थिर वैद्युतिकी'],
  ['magnetism and matter', 'चुंबकत्व एवं पदार्थ'],
  ['thermodynamics', 'ऊष्मागतिकी'],
  ['chemical bonding', 'रासायनिक बंधन'],
  ['atomic structure', 'परमाणु संरचना'],
  ['equilibrium', 'साम्यावस्था'],
  ['cell: structure and function', 'कोशिका: संरचना एवं कार्य'],
  ['genetics', 'आनुवंशिकी'],
  ['sequences & series', 'अनुक्रम और श्रेणी'],
  ['sequence vs series', 'अनुक्रम बनाम श्रेणी'],
  ['arithmetic progression (ap)', 'समान्तर श्रेणी (AP)'],
  ['geometric progression (gp)', 'गुणोत्तर श्रेणी (GP)'],
  ['harmonic progression (hp)', 'हरात्मक श्रेणी (HP)'],
  ['am, gm, hm and the inequality', 'AM, GM, HM और असमता'],
  ['arithmetico-geometric progression (agp)', 'अंकगणित-गुणोत्तर श्रेणी (AGP)'],
  ['sums of special series', 'विशेष श्रेणियों के योग'],
  ['method of differences (telescoping)', 'अंतर विधि (टेलिस्कोपिंग)'],
  ['a **sequence** is a function whose domain is the set of natural numbers (or a subset of it). the image $a_1, a_2, a_3, \\ldots$ is the sequence; $a_n$ is the **n-th term** or **general term**.', 'एक **अनुक्रम** ऐसा फलन है जिसका प्रांत प्राकृतिक संख्याओं का समुच्चय (या उसका उपसमुच्चय) होता है। इसका रूप $a_1, a_2, a_3, \\ldots$ अनुक्रम कहलाता है; $a_n$ को **n-वाँ पद** या **सामान्य पद** कहते हैं।'],
  ['a **series** is the sum of terms of a sequence: $s = a_1 + a_2 + a_3 + \\ldots$. a **finite series** has finitely many terms; otherwise it is **infinite**.', 'एक **श्रेणी** अनुक्रम के पदों का योग होती है: $S = a_1 + a_2 + a_3 + \\ldots$। **परिमित श्रेणी** में सीमित पद होते हैं; अन्यथा वह **अनंत** होती है।'],
  ['sequences may be **finite, infinite, increasing, decreasing, bounded** or **unbounded**.', 'अनुक्रम **परिमित, अनंत, वर्धमान, ह्रासमान, सीमित** या **असीमित** हो सकते हैं।'],
  ['a sequence is in **arithmetic progression** if the difference between consecutive terms is constant. this common difference is denoted $d$.', 'यदि क्रमागत पदों का अंतर स्थिर हो, तो अनुक्रम **समान्तर श्रेणी** में होता है। इस उभयनिष्ठ अंतर को $d$ से दर्शाते हैं।'],
  ['the $r$-th term from the end of an ap with $n$ terms is the $(n - r + 1)$-th term from the beginning, i.e. $t_{n-r+1} = a + (n - r)d$.', '$n$ पदों वाली AP का अंत से $r$-वाँ पद, प्रारंभ से $(n-r+1)$-वाँ पद होता है, अर्थात $T_{n-r+1} = a + (n-r)d$।'],
  ['**symmetric tricks** for choosing ap terms:\n• 3 terms: $a-d, a, a+d$ (sum $= 3a$).\n• 4 terms: $a-3d, a-d, a+d, a+3d$ (common difference $2d$).\n• 5 terms: $a-2d, a-d, a, a+d, a+2d$.', '**सममित युक्तियाँ** (AP पद चुनने हेतु):\n• 3 पद: $a-d, a, a+d$ (योग $= 3a$)।\n• 4 पद: $a-3d, a-d, a+d, a+3d$ (उभयनिष्ठ अंतर $2d$)।\n• 5 पद: $a-2d, a-d, a, a+d, a+2d$।'],
  ['visual contrast: ap (left) grows linearly with constant gap; gp (right) grows multiplicatively.', 'दृश्य तुलना: AP (बाएँ) स्थिर अंतर के साथ रैखिक रूप से बढ़ती है; GP (दाएँ) गुणात्मक रूप से बढ़ती है।'],
  ['a sequence is in **geometric progression** if the ratio of consecutive terms is constant. this common ratio is denoted $r$ ($r \\ne 0$).', 'यदि क्रमागत पदों का अनुपात स्थिर हो, तो अनुक्रम **गुणोत्तर श्रेणी** में होता है। इस उभयनिष्ठ अनुपात को $r$ से दर्शाते हैं ($r \\ne 0$)।'],
  ['**symmetric tricks**:\n• 3 terms: $a/r, a, ar$ (product $= a^3$).\n• 4 terms: $a/r^3, a/r, ar, ar^3$ (common ratio $r^2$).', '**सममित युक्तियाँ**:\n• 3 पद: $a/r, a, ar$ (गुणनफल $= a^3$)।\n• 4 पद: $a/r^3, a/r, ar, ar^3$ (उभयनिष्ठ अनुपात $r^2$)।'],
  ['a sequence $a_1, a_2, a_3, \\ldots$ ($a_i \\ne 0$) is in **harmonic progression** if its reciprocals $1/a_1, 1/a_2, 1/a_3, \\ldots$ form an ap.', 'यदि अनुक्रम $a_1, a_2, a_3, \\ldots$ ($a_i \\ne 0$) के व्युत्क्रम $1/a_1, 1/a_2, 1/a_3, \\ldots$ AP बनाते हों, तो वह **हरात्मक श्रेणी (HP)** कहलाता है।'],
  ['there is no closed-form formula for $s_n$ of an hp in general; convert to ap via reciprocals.', 'सामान्यतः HP के $S_n$ का कोई सरल बंद-रूप सूत्र नहीं होता; व्युत्क्रम लेकर AP में बदलकर हल करें।'],
  ['for $a, b > 0$: $\\;\\;am = \\dfrac{a+b}{2}, \\quad gm = \\sqrt{ab}, \\quad hm = \\dfrac{2ab}{a+b}.$', '$a, b > 0$ के लिए: $\\;\\;AM = \\dfrac{a+b}{2}, \\quad GM = \\sqrt{ab}, \\quad HM = \\dfrac{2ab}{a+b}.$'],
  ['for positive reals, $\\;am \\ge gm \\ge hm,\\;$ with equality iff all numbers are equal. also $gm^2 = am \\cdot hm$.', 'धनात्मक वास्तविक संख्याओं के लिए $\\;AM \\ge GM \\ge HM,\\;$ तथा समता तभी जब सभी संख्याएँ समान हों। साथ ही $GM^2 = AM \\cdot HM$।'],
  ['an agp is the term-by-term product of an ap and a gp. general form: $a, (a+d)r, (a+2d)r^2, \\ldots$.', 'AGP, AP और GP के पदानुसार गुणनफल से बनती है। सामान्य रूप: $a, (a+d)r, (a+2d)r^2, \\ldots$।'],
  ['**standard trick**: write $s$, multiply both sides by $r$, subtract; the middle terms become a gp.', '**मानक युक्ति**: पहले $S$ लिखें, दोनों पक्षों को $r$ से गुणा करें, फिर घटाएँ; बीच के पद GP बनाते हैं।'],
  ['when $t_n$ can be written as $f(n) - f(n-1)$ (or similar), $\\sum_{k=1}^{n} t_k$ telescopes:', 'जब $T_n$ को $f(n) - f(n-1)$ (या समान रूप) में लिखा जा सके, तब $\\sum_{k=1}^{n} T_k$ टेलिस्कोपिक योग बनता है:'],
  ['n-th term of ap', 'AP का n-वाँ पद'],
  ['sum of first n terms; l = last term', 'प्रथम n पदों का योग; जहाँ l अंतिम पद है'],
  ['term-from-end', 'अंत से पद'],
  ['n-th term of gp', 'GP का n-वाँ पद'],
  ['sum of first n terms', 'प्रथम n पदों का योग'],
  ['sum of infinite gp', 'अनंत GP का योग'],
  ['find the sum of all 3-digit natural numbers divisible by 7.', '7 से विभाज्य सभी 3-अंकीय प्राकृतिक संख्याओं का योग ज्ञात कीजिए।'],
  ['first such number = 105, last = 994, $d = 7$. $n = (994 - 105)/7 + 1 = 128$. $s = \\tfrac{128}{2}(105 + 994) = 64 \\times 1099 = 70336$.', 'पहली संख्या $105$ और अंतिम $994$ है, तथा $d = 7$। अतः $n = (994 - 105)/7 + 1 = 128$। इसलिए $S = \\tfrac{128}{2}(105 + 994) = 64 \\times 1099 = 70336$।'],
  ['find the sum of the infinite series $1 + \\tfrac{1}{2} + \\tfrac{1}{4} + \\tfrac{1}{8} + \\ldots$', 'अनंत श्रेणी $1 + \\tfrac{1}{2} + \\tfrac{1}{4} + \\tfrac{1}{8} + \\ldots$ का योग ज्ञात कीजिए।'],
  ['$a = 1$, $r = 1/2$, $|r| < 1$, so $s_\\infty = \\dfrac{1}{1 - 1/2} = 2$.', '$a = 1$, $r = 1/2$, तथा $|r| < 1$ होने से $S_\\infty = \\dfrac{1}{1 - 1/2} = 2$।'],
  ['find the 10th term of the hp $1, \\tfrac{1}{3}, \\tfrac{1}{5}, \\tfrac{1}{7}, \\ldots$', 'HP $1, \\tfrac{1}{3}, \\tfrac{1}{5}, \\tfrac{1}{7}, \\ldots$ का 10वाँ पद ज्ञात कीजिए।'],
  ['reciprocals are $1, 3, 5, 7, \\ldots$ — an ap with $a = 1, d = 2$. $t_{10}^{ap} = 1 + 9(2) = 19$. so $t_{10}^{hp} = 1/19$.', 'व्युत्क्रम $1, 3, 5, 7, \\ldots$ हैं, जो $a = 1, d = 2$ वाली AP है। अतः $T_{10}^{AP} = 1 + 9(2) = 19$ और इसलिए $T_{10}^{HP} = 1/19$।'],
  ['means of two positive numbers', 'दो धनात्मक संख्याओं के माध्य'],
  ['am–gm–hm inequality', 'AM–GM–HM असमता'],
  ['for a = 1 and b = 9: hm = 1.8, gm = 3, am = 5. notice gm² = 9 = 1.8 × 5 = am·hm.', '$a = 1$ और $b = 9$ के लिए: HM = 1.8, GM = 3, AM = 5। ध्यान दें, $GM^2 = 9 = 1.8 \\times 5 = AM \\cdot HM$।'],
  ['for $n$ positive reals $a_1, \\ldots, a_n$, the inequality generalises:', '$n$ धनात्मक वास्तविक संख्याओं $a_1, \\ldots, a_n$ के लिए यह असमता सामान्यीकृत रूप में:'],
  ['if $a + b + c = 6$ and $a, b, c > 0$, find the maximum value of $abc$.', 'यदि $a + b + c = 6$ तथा $a, b, c > 0$ हों, तो $abc$ का अधिकतम मान ज्ञात कीजिए।'],
  ['by am–gm, $\\dfrac{a+b+c}{3} \\ge \\sqrt[3]{abc} \\Rightarrow 2 \\ge \\sqrt[3]{abc} \\Rightarrow abc \\le 8$. maximum occurs at $a = b = c = 2$.', 'AM–GM से $\\dfrac{a+b+c}{3} \\ge \\sqrt[3]{abc} \\Rightarrow 2 \\ge \\sqrt[3]{abc} \\Rightarrow abc \\le 8$। अधिकतम मान $a = b = c = 2$ पर प्राप्त होता है।'],
  ['find $s = 1 + 2x + 3x^2 + 4x^3 + \\ldots$ for $|x| < 1$.', '$|x| < 1$ के लिए $S = 1 + 2x + 3x^2 + 4x^3 + \\ldots$ ज्ञात कीजिए।'],
  ['multiply by $x$: $xs = x + 2x^2 + 3x^3 + \\ldots$. subtract: $(1 - x)s = 1 + x + x^2 + \\ldots = \\dfrac{1}{1-x}$. so $s = \\dfrac{1}{(1-x)^2}$.', '$x$ से गुणा करें: $xS = x + 2x^2 + 3x^3 + \\ldots$। घटाने पर $(1 - x)S = 1 + x + x^2 + \\ldots = \\dfrac{1}{1-x}$। अतः $S = \\dfrac{1}{(1-x)^2}$।'],
  ['**pattern**: $\\sum k(k+1)(k+2)\\cdots(k+r-1) = \\dfrac{n(n+1)(n+2)\\cdots(n+r)}{r+1}$. memorise this telescoping pattern — saves time on jee.', '**पैटर्न**: $\\sum k(k+1)(k+2)\\cdots(k+r-1) = \\dfrac{n(n+1)(n+2)\\cdots(n+r)}{r+1}$। यह टेलिस्कोपिक पैटर्न याद रखें, JEE में समय बचता है।'],
  ['find $\\sum_{k=1}^{n} k(k+1)$.', '$\\sum_{k=1}^{n} k(k+1)$ ज्ञात कीजिए।'],
  ['$\\sum k^2 + \\sum k = \\dfrac{n(n+1)(2n+1)}{6} + \\dfrac{n(n+1)}{2} = \\dfrac{n(n+1)(n+2)}{3}$.', '$\\sum k^2 + \\sum k = \\dfrac{n(n+1)(2n+1)}{6} + \\dfrac{n(n+1)}{2} = \\dfrac{n(n+1)(n+2)}{3}$।'],
  ['find $\\sum_{k=1}^{n} \\dfrac{1}{k(k+1)}$.', '$\\sum_{k=1}^{n} \\dfrac{1}{k(k+1)}$ ज्ञात कीजिए।'],
  ['use partial fractions: $\\dfrac{1}{k(k+1)} = \\dfrac{1}{k} - \\dfrac{1}{k+1}$. sum telescopes: $1 - \\dfrac{1}{n+1} = \\dfrac{n}{n+1}$.', 'आंशिक भिन्नों का उपयोग करें: $\\dfrac{1}{k(k+1)} = \\dfrac{1}{k} - \\dfrac{1}{k+1}$। योग टेलिस्कोपिक होगा: $1 - \\dfrac{1}{n+1} = \\dfrac{n}{n+1}$।'],
  ['find the sum to infinity of $\\sum_{k=1}^{\\infty} \\dfrac{1}{k(k+1)(k+2)}$.', '$\\sum_{k=1}^{\\infty} \\dfrac{1}{k(k+1)(k+2)}$ का अनंत तक योग ज्ञात कीजिए।'],
  ['decompose: $\\dfrac{1}{k(k+1)(k+2)} = \\dfrac{1}{2}\\left[\\dfrac{1}{k(k+1)} - \\dfrac{1}{(k+1)(k+2)}\\right]$. telescopes to $\\dfrac{1}{2}\\cdot\\dfrac{1}{1\\cdot 2} = \\dfrac{1}{4}$.', 'विघटन करें: $\\dfrac{1}{k(k+1)(k+2)} = \\dfrac{1}{2}\\left[\\dfrac{1}{k(k+1)} - \\dfrac{1}{(k+1)(k+2)}\\right]$। टेलिस्कोपिक योग से मान $\\dfrac{1}{2}\\cdot\\dfrac{1}{1\\cdot 2} = \\dfrac{1}{4}$ मिलता है।'],
]);

export const VERIFIED_RULE_OVERRIDES = [
  [/\bset(s)?\b/gi, 'समुच्चय'],
  [/\brelation(s)?\b/gi, 'संबंध'],
  [/\bdifferentiation\b/gi, 'अवकलन'],
  [/\bderivative(s)?\b/gi, 'अवकलज'],
  [/\bdifferential equation(s)?\b/gi, 'अवकल समीकरण'],
  [/\bintegration\b/gi, 'समाकलन'],
  [/\bdefinite integral\b/gi, 'निश्चित समाकल'],
  [/\bindefinite integral\b/gi, 'अनिश्चित समाकल'],
  [/\blimit(s)?\b/gi, 'सीमा'],
  [/\bcontinuity\b/gi, 'सततता'],
  [/\bdifferentiability\b/gi, 'अवकलनीयता'],
  [/\bfunction(s)?\b/gi, 'फलन'],
  [/\bsequence(s)?\b/gi, 'अनुक्रम'],
  [/\bseries\b/gi, 'श्रेणी'],
  [/\bpermutation\b/gi, 'क्रमचय'],
  [/\bcombination\b/gi, 'संचय'],
  [/\bvector(s)?\b/gi, 'सदिश'],
  [/\bmatrix\b/gi, 'आव्यूह'],
  [/\bdeterminant\b/gi, 'सारणिक'],
  [/\btrigonometry\b/gi, 'त्रिकोणमिति'],
  [/\bprobability\b/gi, 'प्रायिकता'],
  [/\bcoordinate geometry\b/gi, 'निर्देशांक ज्यामिति'],
  [/\bkinematics\b/gi, 'गतिकी'],
  [/\bvelocity\b/gi, 'वेग'],
  [/\bacceleration\b/gi, 'त्वरण'],
  [/\bforce\b/gi, 'बल'],
  [/\bmomentum\b/gi, 'संवेग'],
  [/\bwork\b/gi, 'कार्य'],
  [/\bpower\b/gi, 'शक्ति'],
  [/\benergy\b/gi, 'ऊर्जा'],
  [/\belectric field\b/gi, 'विद्युत क्षेत्र'],
  [/\bpotential difference\b/gi, 'विभवांतर'],
  [/\bcurrent\b/gi, 'धारा'],
  [/\bresistance\b/gi, 'प्रतिरोध'],
  [/\bcapacitance\b/gi, 'धारिता'],
  [/\bmagnetic field\b/gi, 'चुंबकीय क्षेत्र'],
  [/\bthermodynamics\b/gi, 'ऊष्मागतिकी'],
  [/\batom\b/gi, 'परमाणु'],
  [/\bmolecule\b/gi, 'अणु'],
  [/\belement\b/gi, 'तत्त्व'],
  [/\bcompound\b/gi, 'यौगिक'],
  [/\boxidation\b/gi, 'ऑक्सीकरण'],
  [/\breduction\b/gi, 'अपचयन'],
  [/\bequilibrium\b/gi, 'साम्यावस्था'],
  [/\bhybridization\b/gi, 'संकरण'],
  [/\borbital\b/gi, 'कक्षक'],
  [/\bcell\b/gi, 'कोशिका'],
  [/\btissue\b/gi, 'ऊतक'],
  [/\bgene\b/gi, 'जीन'],
  [/\bchromosome\b/gi, 'गुणसूत्र'],
  [/\bphotosynthesis\b/gi, 'प्रकाश संश्लेषण'],
  [/\brespiration\b/gi, 'श्वसन'],
];

export const VERIFIED_FIX_REPLACEMENTS = [
  [/अनुक्रम बनाम श्रृंखला/g, 'अनुक्रम बनाम श्रेणी'],
  [/एक \*\*श्रृंखला\*\* एक अनुक्रम के पदों का योग है/g, 'एक **श्रेणी** अनुक्रम के पदों का योग है'],
  [/परिमित श्रृंखला/g, 'परिमित श्रेणी'],
  [/अनंत श्रृंखला/g, 'अनंत श्रेणी'],
  [/श्रृंखला उत्पाद/g, 'श्रेणी गुणनफल'],
  [/समान्तर श्रेढ़ी/g, 'समान्तर श्रेणी'],
  [/गुणोत्तर श्रेढ़ी/g, 'गुणोत्तर श्रेणी'],
  [/हरात्मक श्रेढ़ी/g, 'हरात्मक श्रेणी'],
  [/एपी/g, 'AP'],
  [/जीपी/g, 'GP'],
  [/एचपी/g, 'HP'],
  [/एजीपी/g, 'AGP'],
  [/एएम/g, 'AM'],
  [/जीएम/g, 'GM'],
  [/एचएम/g, 'HM'],
  [/सेट, संबंध और कार्य/g, 'सेट, संबंध और फलन'],
  [/अनिश्चितकालीन इंटीग्रल/g, 'अनिश्चित समाकलन'],
  [/अनिश्चित इंटीग्रल/g, 'अनिश्चित समाकलन'],
  [/विभेदक समीकरण/g, 'अवकल समीकरण'],
  [/सीमाएँ, निरंतरता और भिन्नता/g, 'सीमा, सततता तथा अवकलनीयता'],
  [/सीमाएं, निरंतरता और भिन्नता/g, 'सीमा, सततता तथा अवकलनीयता'],
  [/व्युत्पन्नों का विभेदन और अनुप्रयोग/g, 'अवकलन तथा उसके अनुप्रयोग'],
  [/कार्य\) की संख्या/g, 'फलन) की संख्या'],
  [/कार्यों की संख्या/g, 'फलनों की संख्या'],
  [/ऑन्टो फ़ंक्शंस/g, 'आच्छादक फलनों'],
  [/ऑन्टो फंक्शंस/g, 'आच्छादक फलनों'],
  [/विशेषण: एक-एक और आच्छादक दोनों। केवल इनके विपरीत कार्य होते हैं/g, 'द्विएक: एक-एक और आच्छादक दोनों। केवल द्विएक फलनों का ही व्युत्क्रम होता है।'],
  [/रिफ्लेक्टिव/g, 'प्रतिवर्ती'],
  [/रिफ्लेक्सिव/g, 'प्रतिवर्ती'],
  [/एंटीसिमेट्रिक/g, 'प्रतिसममित'],
  [/ट्रांजिटिव/g, 'सकर्मक'],
  [/अजीब फलन/g, 'विषम फलन'],
  [/इन्वर्टिबिलिटी/g, 'व्युत्क्रमणीयता'],
  [/भेदभाव/g, 'अवकलन'],
  [/डिफरेंशिएशन/gi, 'अवकलन'],
  [/फ़ंक्शन/g, 'फलन'],
  [/फंक्शन/g, 'फलन'],
  [/वेक्टर/g, 'सदिश'],
  [/मैट्रिक्स/gi, 'आव्यूह'],
  [/तत्व/g, 'तत्त्व'],
  [/कम्पाउंड/gi, 'यौगिक'],
  [/मोलिक्यूल/gi, 'अणु'],
  [/डिटरमिनेंट/gi, 'सारणिक'],
  [/जाल/g, 'सामान्य त्रुटि'],
  [/फंदा/g, 'सामान्य त्रुटि'],
];
